import React from 'react';
import { cn } from '@/lib/utils';
import { Card, CardContent } from '@/components/ui/card';

export function StatCard({ 
    label, 
    value, 
    icon: Icon,
    trend,
    trendValue,
    className 
}) {
    const formattedValue = typeof value === 'number' 
        ? value.toLocaleString() 
        : value;

    return (
        <Card className={cn("bg-card", className)}>
            <CardContent className="pt-6">
                <div className="flex items-start justify-between">
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-muted-foreground">
                            {label}
                        </p>
                        <p className="text-3xl font-bold text-foreground tracking-tight">
                            {formattedValue}
                        </p>
                        {trend && (
                            <p className={cn(
                                "text-xs font-medium",
                                trend === 'up' && "text-green-600",
                                trend === 'down' && "text-red-600",
                                trend === 'neutral' && "text-muted-foreground"
                            )}>
                                {trendValue}
                            </p>
                        )}
                    </div>
                    {Icon && (
                        <div className="p-2 rounded-lg bg-primary/10">
                            <Icon className="h-5 w-5 text-primary" />
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}

export default StatCard;

